import React, {Component} from 'react';
import {Button, Grid, Typography, withStyles} from "@material-ui/core";
import {injectIntl, intlShape} from 'react-intl';
import {connect} from 'react-redux';
import MfaMobilePhone from './MfaMobilePhone'
import MfaTotp from './MfaTotp';
import {bindActionCreators} from "redux";
import {loginWatcher} from "../../redux/actions/loginactioncreators";
import messages from "../../messages";
import styles from "../../styles";
import flowStages from "../../flowStages";
import challengeShape from "../../proptypes/challengeShape";
import PropTypes from 'prop-types';
class MfaSetup extends Component {
  constructor(props) {
    super(props)
    this.state = {
      mobileNumber: "",
    }
  }

  handleChange = value => {
    this.setState({
      mobileNumber: value,
    });
  };

  handleOnSubmit = () => {
    let newState = this.state;
    newState.loginErrorMessages = [];
    this.setState(newState);
    this.props.loginWatcher(
      {
        flowStage: flowStages.CHALLENGE_MFA_SETUP,
        challengeResponse: {
          session: this.props.challenge.session,
          challengeName: this.props.challenge.challengeName,
          step: "MFA_SETUP_COMPLETE",
          challengeParameters: {
            USERNAME: this.props.challenge.challengeParameters.USER_ID_FOR_SRP,
            PASSWORD: this.props.password
          }
        }
      }
    )
  }

  render() {
    const {classes} = this.props;
    const {formatMessage} = this.props.intl;
    const mfaOptions = this.props.challenge.challengeParameters['MFA_OPTIONS'];
    const mfaComplete = mfaOptions['SMS'] === 'enabled' || mfaOptions['TOTP'] === 'enabled';
    return (
      <main className={classes.layout}>
        <Grid container>
          <Grid item xs={12}>
            <Typography variant="h6">{formatMessage(messages.mfaSetupTitle)}</Typography>
            <Typography>{formatMessage(messages.mfaSetupBlurb)}</Typography>
            <br/>
            <MfaMobilePhone complete={mfaOptions['SMS'] === 'enabled'}></MfaMobilePhone>
            <MfaTotp complete={mfaOptions['TOTP'] === 'enabled'}></MfaTotp>

            {/*{!this.props.challenge.challengeParameters['REQUIRED'] &&*/}
            {/*<Button variant="contained" color="primary">{formatMessage(messages.mfaSkip)}</Button>*/}
            {/*}*/}
          </Grid>

        </Grid>
        <Grid container justify="flex-end">
          <Grid item>
            <Button
              id="mfaSetupComplete"
              name="mfaSetupComplete"
              onClick={this.handleOnSubmit}
              variant='contained'
              color="primary"
              disabled={!mfaComplete}
            >
              {formatMessage(messages.mfaComplete)}
            </Button>
          </Grid>
        </Grid>
      </main>
    )
  }
}
MfaSetup.propTypes = {
  challenge: challengeShape,
  intl: intlShape,
  loginWatcher: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  password: PropTypes.string,
}
const mapStateToProps = state => {
  return {
    loginErrorMessages: state.loginForm.loginErrorMessages,
    challenge: state.loginForm.challenge,
    extraData: state.loginForm.extraData,
    userInfo: state.loginForm.userInfo,
    username: state.loginForm.username,
    password: state.loginForm.password,
    mfaComplete: state.loginForm.mfaComplete
  }
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    loginWatcher
    // add other watcher sagas to this object to map them to props
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(withStyles(styles)(MfaSetup)))